import * as defaultImport from "@splunk/react-icons/ArrowsCircularDouble";
export * from "@splunk/react-icons/ArrowsCircularDouble";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
